export function tutorialMixin() {
    return {
        props: ['game'],

        computed: {
            language() {
                const supportedLanguages = ['en', 'es', 'fr', 'lt', 'ru'];

                if (supportedLanguages.includes(Config.language)) {
                    return Config.language;
                }

                return 'en';
            },
        },

        methods: {
            url(name) {
                let postFix = Config.theme ? '_dark' : '';
                let gameName = this.game.name;

                if (!Config.theme && ['stats', 'actives_wins'].includes(name)) {
                    gameName = 'general';
                }

                const additionalPostFixes = Config.games[this.game.id].tutorial_img_postfix;

                if (additionalPostFixes) {
                    if (additionalPostFixes[name]) {
                        postFix += additionalPostFixes[name];
                    }
                }

                return `/tv/v2/how_to_play/${gameName}/${this.language}/${name}${postFix}.webp?v=10`;
            },
        },
    };
}